import {Component} from "@angular/core";

@Component({
    selector: "fui-actions",
    styleUrls: ["./actions.component.scss"],
    templateUrl: "./actions.component.html"
})
export class FUIActionsComponent {
    constructor() {

    }
}
